import { render, staticRenderFns } from "./MoodleAccountDetails.vue?vue&type=template&id=7a2284b8"
import script from "./MoodleAccountDetails.vue?vue&type=script&lang=js"
export * from "./MoodleAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports